import { ContainerProps, Container } from "@mui/material";

interface UserPageContainerProps extends ContainerProps {};

function UserPageContainer(props: UserPageContainerProps) {
    return <Container {...props} />
};

export default UserPageContainer;